import { render, staticRenderFns } from "./PrivacyPage.vue?vue&type=template&id=42ed8693&"
import script from "./PrivacyPage.vue?vue&type=script&lang=js&"
export * from "./PrivacyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports